import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Field, TextInput } from "@/components/forms";
import { btn } from "@/components/ui-kit";
import Seo from "@/components/Seo";
import { Lock, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await login(email.trim(), password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Login failed. Please try again.";
      setError(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-forest flex items-center justify-center px-6 relative overflow-hidden" data-testid="admin-login-page">
      <div className="grain" />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <div className="mx-auto w-14 h-14 rounded-sm bg-gold/15 flex items-center justify-center">
            <Lock size={26} className="text-gold" />
          </div>
          <h1 className="mt-5 font-serif text-3xl font-semibold text-white">Admin Sign In</h1>
          <p className="mt-2 text-white/50 text-sm">Redwood Capital Holdings — Submissions Dashboard</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-sm p-8 space-y-5 shadow-2xl" data-testid="admin-login-form">
          <Seo title="Admin Sign In" description="Redwood Capital Holdings admin dashboard." path="/admin/login" />
          <Field label="Email">
            <TextInput type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@redwoodcaphold.com" data-testid="admin-email" required />
          </Field>
          <Field label="Password">
            <TextInput type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="admin-password" required />
          </Field>
          {error && <p className="text-sm text-destructive font-medium" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={busy} className={`${btn.forest} w-full disabled:opacity-60`} data-testid="admin-login-submit">
            {busy ? "Signing in…" : "Sign In"} {!busy && <ArrowRight size={18} />}
          </button>
        </form>
      </div>
    </div>
  );
}
